<template>
  <v-badge
    v-if="sourceId"
    color="red"
    :content="newEvents"
    :offset-x="$vuetify.breakpoint.mobile ? 26 : 36"
    :offset-y="$vuetify.breakpoint.mobile? 16 : 24"
    :value="!!newEvents"
  >
    <v-btn
        class="mr-3"
        icon
        :small="$vuetify.breakpoint.mobile"
        @click="toEvents"
    >
      <v-icon>
        mdi-bell
      </v-icon>
    </v-btn>
  </v-badge>
</template>

<script>
import {getSourceId} from '@/composables/context'
import {appStates} from '@/constants'
export default {
  name: 'EventsPreview',
  computed: {
    sourceId: getSourceId
  },
  data () {
    return {
      newEvents: 0
    }
  },
  methods: {
    toEvents: function () {
      this.$client.post(this.$API.EVENTS.DATE_SET)
          .then(() => this.newEvents = 0)
      this.$router.push({name: appStates.sourceItemEventList.name, params: {sourceId: this.sourceId}})
    }
  },
  watch: {
    sourceId: {
      handler: function (sourceId) {
        if (!sourceId) {
          this.newEvents = 0
        } else {
          this.$client.get(this.$API.EVENTS.NEW_SIZE, {params: {sourceId: sourceId}})
              .then(data => this.newEvents = data.size)
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped>

</style>
